'use strict';

import {
    DOMUtils,
    HttpRequest,
    escapeHtml
} from "./Utils";
import {
    getAttr,
    resetAttr,
    setAttr
} from "./options";
import {
    getCookie,
    setCookie,
    cookieEnum,
    removeCookie
} from "./cookie";
import {
    navButtonsHideAll
} from "./navButtons.js"

import {
    customAlert,
    customConfirm,
    closeDialogs,
    closeOneDialog,
    appendDialog,

    navBarClose,
    resetNavbar,

    abmelden,
} from "./dialog.js";

import {
    createRoom,
    createDataRowElem
} from "./roombuilder";

const liste = {
    start() {
        // TODO
        startScreen();
    },

    close() {
        // stopScreen();
    }
};

// roomItemListener

window.$DOM = DOMUtils;

var removeRoomBild = false;
var removeRoomBild2 = false;
var removeRoomBild3 = false;
var removeRoomBild4 = false;
var removeBild1 = false;
var removeBild2 = false;
var removeBild = false;

function startScreen() {
    const user = getAttr("user");

    if (user) {
        navButtonsHideAll();

        const btnuser = $DOM("#btn-user-name");
        btnuser.html(escapeHtml(user.orgname));
        btnuser.removeClass("hidden");

        loadDatagroups();
    } else {

        window.location = "#home";
    }
}

function btnBackListe() {

    const modal = $DOM("#imageModal").getElm();
    if (modal) {
        if (modal.style.display === "block") {
            modal.style.display = "none";
            window.history.pushState(null, "", window.location.href);
            return;
        }
    }

    const content = $DOM("#content-wrapper").getElm();
    if (content) {
        if (content.scrollTop) {
            // todo: animate scroll
            //content.scrollTop = 0;
            content.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });

            window.history.pushState(null, "", window.location.href);
        } else {
            loadDatagroups();
            window.history.pushState(null, "", window.location.href);
        }
    }
    return;
}

function scrollToRoom(elem) {
    closeDialogs();
    const room = elem.getAttribute("data-rId");
    const content = $DOM("#content-wrapper").getElm();

    if (room && content) {
        const roomElem = $DOM(`#${room}`).getElm();
        if (roomElem) {
            const topPos = roomElem.offsetTop;

            // content.scrollTop = topPos;

            content.scrollTo({
                top: topPos,
                left: 0,
                behavior: "smooth"
            });
        }
    }
};

function scrollToRoomItem(elem) {
    const content = $DOM("#content-wrapper").getElm();

    if (content && elem) {
        const topPos = elem.offsetTop;
        // content.scrollTop = topPos;
        content.scrollTo({
            top: topPos,
            left: 0,
            behavior: "smooth"
        });
    }
}

$DOM(window).on("sendrequest", function (e) {
    $DOM("#loader").removeClass("hidden");
});
$DOM(window).on("donerequest", function (e) {
    $DOM("#loader").addClass("hidden");
});

function loadDatagroups() {
    navBarClose();
    const user = getAttr("user");

    if (user) {
        const data = {
            url: "./php/api/datagroup/read.php",
            data: {
                userid: user.id,
                uid: user.uid
            }
        };

        const req = new HttpRequest();
        req.done(function (e) {
            setAttr("datagroups", e);
            updateNavbarDatagroups();
        }).fail(function (e) {
            setAttr("datagroups", e);
            loadDataFail();
        });
        req.send(data);
    }
}

function loadDataFail() {
    resetNavbar();

    $DOM("#dropdown-items").addClass("hidden");

    $DOM("#list-screen").html(`<div class="screen-block liste">\n` +
        `<span style="display: block;">Keine Daten gefunden</span>` +
        `<button id="create-group" class="screen-button">Gruppe anlegen</button>\n` +
        `</div>`);

    $DOM("#create-group").on("click", function () {
        createGroup();
    });

}

function benutzerVerwaltung() {
    navBarClose();
    const user = getAttr("user");

    $DOM("#showUserInfoModal").removeClass("hidden");
    appendDialog($DOM("#showUserInfoModal"));

    $DOM("#userInfo-email").html(escapeHtml(user.username));
    $DOM("#userInfo-name").html(escapeHtml(user.fullname));
    $DOM("#userInfo-orgname").html(escapeHtml(user.orgname));
    if (user.isgroupaccount == 0 || user.admin == 1) {
        $DOM("#userInfo-pwNotAllowed").addClass("hidden");
        $DOM("#userInfo-pw-tr").removeClass("hidden");
        $DOM("#userInfo-pw2-tr").removeClass("hidden");
        $DOM("#userInfo-newpw-tr").removeClass("hidden");
        $DOM("#userInfo-btnsaveNewPw").off();
        $DOM("#userInfo-btnsaveNewPw").on("click", sendUpdatePw);
    } else {
        $DOM("#userInfo-pwNotAllowed").removeClass("hidden");
        $DOM("#userInfo-pw-tr").addClass("hidden");
        $DOM("#userInfo-pw2-tr").addClass("hidden");
        $DOM("#userInfo-newpw-tr").addClass("hidden");
        $DOM("#userInfo-btnsaveNewPw").off();
    }

    $DOM("#userInfo-btncancel").on("click", closeDialogs);
    const btnLogout = $DOM("#userInfo-logout");
    btnLogout.off();
    btnLogout.on("click", function (e) {
        closeDialogs();
        customConfirm("Sicher das du dich Abmelden willst?", function () {
            abmelden();
        });
    });
}

function sendUpdatePw() {
    $DOM("#userInfo-form-error").html("");

    if (!$DOM("#userInfo-pw").val()) {
        $DOM("#userInfo-form-error").html("Bitte Passwort angeben");
        return;
    } else if ($DOM("#userInfo-pw").val().length < 4) {
        $DOM("#userInfo-form-error").html("Passwort muss mindestens 4 Zeichen lang sein!");
        return;
    } else if (!$DOM("#userInfo-pw2").val()) {
        $DOM("#userInfo-form-error").html("Bitte Passwort Wiederholung angeben");
        return;
    } else if ($DOM("#userInfo-pw").val() != $DOM("#userInfo-pw2").val()) {
        $DOM("#userInfo-form-error").html("Passwörter stimmen nicht überein");
        return;
    }

    const user = getAttr("user");

    new HttpRequest().send({
        url: "./php/api/user/updatePw.php",
        type: "POST",
        data: {
            email: user.username,
            pw: $DOM("#userInfo-pw").val(),
            id: user.id,
            uid: user.uid
        }
    }).done(function (e) {
        $DOM("#showUserInfoModal").clearForm();
        $DOM("#userInfo-form-error").html("Passwort erfolgreich geändert.");
        // closeDialogs();
        // showUserVerwaltung();
    }).fail(function (e) {
        const msg = customAlert(e);
        $DOM("#userInfo-form-error").html(msg);
    });
}

function createGroup() {
    navBarClose();
    $DOM("#createGroupModal").removeClass("hidden");
    appendDialog($DOM("#createGroupModal"));
    $DOM("#dg-btncancel").on("click", closeDialogs);
    $DOM("#dg-btndelete").off();
    $DOM("#dg-btndelete").addClass("hidden");
    $DOM("#dg-btnsave").off();
    $DOM("#dg-btnsave").on("click",
        function (e) {
            const name = $DOM("#dg-name").val();
            let navname = $DOM("#dg-navname").val();
            const info = $DOM("#dg-info").val();
            const besatzung = $DOM("#dg-besatzung").val();
            const sortidx = $DOM("#dg-sortidx").val();
            const bild = $DOM("#dg-bild").getElm().files[0];
            const user = getAttr("user");
            if (name) {
                if (!navname) {
                    navname = name;
                }
                new HttpRequest().send({
                    url: "./php/api/datagroup/create.php",
                    type: "POST",
                    format: "formdata",
                    data: {
                        orgid: user.orgid,
                        name: name,
                        navname: navname,
                        info: info,
                        besatzung: besatzung,
                        sortidx: sortidx,
                        bild: bild,
                        uid: user.uid
                    }
                }).done(function (e) {
                    closeDialogs();
                    loadDatagroups();
                }).fail(function (e) {
                    customAlert(e);
                });
            } else {
                customAlert("Bitte einen Namen angeben");
            }
        });
}

function processRecievedData(e, groupid) {
    // add detail to data
    if (e.detail) {
        // console.log("add Details: ", e.detail.length);
        (e.detail).forEach(elem => {
            var dataElem = (e.data).find(x => x.id === elem.dataid);
            if (dataElem) {
                if (!dataElem.details) {
                    dataElem.details = [];
                }
                if (!elem.lastcheck) {
                    elem.lastcheck = "";
                }
                if (!elem.nextcheck) {
                    elem.nextcheck = "";
                }
                if (!elem.anschaffung) {
                    elem.anschaffung = "";
                }
                if (!elem.auszuscheiden) {
                    elem.auszuscheiden = "";
                }
                dataElem.details.push(elem);
            }
        });
    }
    // console.log("data: ", e.data);
    setAttr("data", e.data);
}

function removeDataAttrItem() {
    var elem = getAttr("data");
    // console.log(elem);
    setAttr("data", elem);
}


function loadData(groupid, clear = false, updateScreen = true, successFunction = false, successFunctionArg = false) {
    let user = getAttr("user");

    if (user && groupid) {
        const data = {
            url: "./php/api/data/read2.php",
            data: {
                userid: user.id,
                uid: user.uid,
                groupid: groupid,
                // Cache-Buster: eindeutige URL pro Request -> keine gecachte (alte)
                // GET-Antwort (Browser/Proxy). read2.php ignoriert diesen Parameter.
                _ts: Date.now()
            }
        };

        const req = new HttpRequest();
        req.done(function (e) {
            
            processRecievedData(e, groupid);

            if (updateScreen) {
                updateNavbarData(e.data, groupid);
            }
            if (successFunction) {
                successFunction(successFunctionArg);
            }
        }).fail(function (e) {
            console.log(e);
            if (clear) {
                $DOM("#list-screen").empty();
            }
            user = getAttr("user");
            if (user && user.admin == 1) {
                createRoomDlg(groupid);
            } else {
                customAlert("Kein Raum vorhanden. Ein Admin deiner Organisation muss einen Raum erstellen.");
            }
        });
        req.send(data);
    }
}


function updateNavbarDatagroups() {
    resetNavbar();
    $DOM("#dropdown-items").removeClass("hidden");
    var nav = $DOM("#dropdown-items");
    var user = getAttr("user");
    if (user.admin == 1) {
        $DOM("#btn-create-group").removeClass("hidden");
        $DOM("#btn-userverwaltung").removeClass("hidden");
    }


    const screen = $DOM("#list-screen");
    screen.empty();

    const datagroups = getAttr("datagroups");
    if (datagroups && datagroups.length > 0) {
        screen.removeClass("room-screen");
        screen.addClass("bg");

        var container = $DOM().create("div");
        container.addClass("content-container");


        datagroups.forEach(function (data, idx) {
            let name;
            if (data.navname) {
                name = data.navname;
            } else if (data.funk) {
                name = data.funk;
            } else {
                name = data.fahrzeug;
            }

            nav.append(`<a role="button" class="nav-link" data-id="${data.id}">${escapeHtml(name)}</a>`);

            let dgItem = `<div class="dg-item" data-id="${data.id}">`;
            if (data.info) {
                dgItem += `<i class="info-icon"></i>`;
            }
            if (user.admin == 1) {
                dgItem += `<i class="dg-edit"></i>`;
            }

            dgItem += `<div class="dg-item-imgbox">`;
            if (data.bild) {
                dgItem += `<img class=""  src="/data/img/${user.oid}/${data.id}/${escapeHtml(data.bild)}" />`;
            } else {
                dgItem += `<img class="" src="./img/default-auto.png" />`;
            }
            dgItem += "</div>";

            dgItem += `<strong class="dg-item-header">${escapeHtml(data.fahrzeug)}</strong>`;

            if (data.besatzung) {
                dgItem += `<span>Besatzung: ${escapeHtml(data.besatzung)}</span>`;
            }
            dgItem += `<span style="display: block;">Räume: ${escapeHtml(data.raumanzahl)}</span>`;
            dgItem += "</div>";

            container.append(dgItem);
        });

        screen.append(container);

        $DOM(".dg-item").on("click", showDetail);
        $DOM(".nav-link").on("click", showDetail);
        if (user.admin == 1) {
            $DOM(".dg-edit").on("click", editDg);
        }
        $DOM(".info-icon").on("click", showInfo);

    } else {
        loadDataFail();
    }
}


function showInfo(e) {
    closeDialogs();
    const elm = $DOM(this);
    const id = elm.parent().attr("data-id");
    e.preventDefault();
    e.stopImmediatePropagation();

    const dg = getDatagroupById(id);
    if (dg) {
        $DOM("#infoModal").removeClass("hidden");
        appendDialog($DOM("#infoModal"));
        // escapeHtml: dg.info ist Nutzertext (read.php gibt ihn per
        // html_entity_decode roh zurueck) -> ohne Escaping Stored-XSS (G6).
        $DOM("#info-txt").html(escapeHtml(dg.info));
        $DOM("#info-btncancel").on("click", closeDialogs);
    }

    return false;
}

function editDg(e) {
    closeDialogs();
    const elm = $DOM(this);
    const id = elm.parent().attr("data-id");
    e.preventDefault();
    e.stopImmediatePropagation();
    editGroup(id);
    return false;
}

function editGroup(id) {
    closeDialogs();
    var dg = getDatagroupById(id);
    if (dg) {
        removeBild = false;
        $DOM("#createGroupModal").removeClass("hidden");
        appendDialog($DOM("#createGroupModal"));
        $DOM("#dg-name").val(dg.fahrzeug);
        $DOM("#dg-navname").val(dg.navname);
        $DOM("#dg-besatzung").val(dg.besatzung);
        $DOM("#dg-info").val(dg.info);
        $DOM("#dg-sortidx").val(dg.sortidx);

        if (dg.bild) {
            $DOM("#dg-bild").parent().append(`<span class="upload-img-name">${reduceName(dg.bild)}<i id="imgbild" class="remove-entry upload-remove"></i></span>`);
        }

        $DOM("#imgbild").on("click", function () {
            removeBild = true;
            $DOM(this).parent().remove();
        });

        $DOM("#dg-btndelete").off();
        $DOM("#dg-btndelete").removeClass("hidden");
        $DOM("#dg-btndelete").on("click", function (e) {
            customConfirm("Sicher das du die Gruppe löschen willst?", function () {
                deleteDataGroup(dg.id);
            });
        });
        $DOM("#dg-btncancel").off();
        $DOM("#dg-btncancel").on("click", closeDialogs);
        $DOM("#dg-btnsave").off();
        $DOM("#dg-btnsave").on("click", function (e) {
            const name = $DOM("#dg-name").val();
            let navname = $DOM("#dg-navname").val();
            const info = $DOM("#dg-info").val();
            const besatzung = $DOM("#dg-besatzung").val();
            const bild = $DOM("#dg-bild").getElm().files[0];
            const user = getAttr("user");
            const sortidx = $DOM("#dg-sortidx").val();

            if (name) {
                if (!navname) {
                    navname = name;
                }
                new HttpRequest().send({
                    url: "./php/api/datagroup/create.php",
                    type: "POST",
                    format: "formdata",
                    data: {
                        id: dg.id,
                        orgid: user.orgid,
                        name: name,
                        navname: navname,
                        info: info,
                        besatzung: besatzung,
                        sortidx: sortidx,
                        bild: bild,
                        removebild: removeBild,
                        uid: user.uid
                    }
                }).done(function (e) {
                    closeDialogs();
                    loadDatagroups();
                }).fail(function (e) {
                    customAlert(e);
                    closeDialogs();
                    loadDatagroups();
                });
            } else {
                customAlert("Bitte einen Namen angeben");
            }
        });
    }
}

function showDetail(e) {
    closeDialogs();
    const id = $DOM(this).attr("data-id");
    loadData(id);
}

function updateNavbarData(data, groupid) {

    if (data) {
        resetNavbar();
        const nav = $DOM("#dropdown-items");
        // nav.append("<a role="button" class="nav-link" id="home">Übersicht</a>");
        nav.append(`<input type="search" placeholder="Suche" autocomplete="off" class="nav-search" />`);

        setAttr("openGid", groupid);


        const user = getAttr("user");
        if (user && user.admin == 1) {
            $DOM("#btn-create-room").removeClass("hidden");
        }

        var timeout = null;
        $DOM(".nav-search").on("keyup", function (e) {
            var value = $DOM(this).val();
            clearTimeout(timeout);
            timeout = setTimeout(function (e) {
                // not needed anymore at least for chrome
                if (value.indexOf("@") > 0) {
                    $DOM(this).val("");
                } else {
                    searchData(value);
                }
            }, 200);
        });

        updateData(data);
    }
}

function updateData(data) {
    var nav = $DOM("#dropdown-items");
    $DOM(".nav-raum").remove();

    const screen = $DOM("#list-screen");
    screen.empty();
    screen.addClass("room-screen");

    var container = $DOM().create("div");
    container.addClass("content-container");

    // console.log(data);
    const raeumeMap = data.map(a => {
        return {
            rid: a.rid,
            raumname: a.raumname,
            raumkurz: a.raumkurz,
            raumkommentar: a.raumkommentar,
            raumbild: a.raumbild,
            raumbild2: a.raumbild2,
            raumbild3: a.raumbild3,
            raumbild4: a.raumbild4,
            sortidx: a.sortidx
        };
    });

    var raeume = [];
    var raeumenames = [];
    raeumeMap.forEach((raum) => {
        if (raeumenames.indexOf(raum.rid) === -1) {
            raeume.push(raum);
            raeumenames.push(raum.rid);
        }
    });

    setAttr("raum", raeume);

    raeume.forEach(function (raum, idx) {
        const dataFilter = data.filter(a => a.rid == raum.rid);

        nav.append(`<span class="nav-link nav-raum nav-clickable" data-rId="room_${raum.rid}");">${escapeHtml(raum.raumkurz)}</a>`);
        navBarClose();
        const roomstr = createRoom(raum, dataFilter);
        container.append(roomstr);
    });

    screen.append(container);
    roomItemListener();

    $DOM("#home").on("click", function (e) {
        loadDatagroups();
    });

    $DOM(".nav-raum").on("click", function (e) {
        scrollToRoom(this);
    });

}


function roomItemHeaderClickHandler(elem) {
    closeDialogs();
    const opened = $DOM(elem).parent().hasClass("show");
    $DOM(".room-item").removeClass("show");
    $DOM(".room-header").removeClass("show");
    if (!opened) {
        const ritem = $DOM(elem).parent();
        ritem.addClass("show");
        scrollToRoomItem(ritem.getElm());
    }
}

function roomItemListener() {
    $DOM(".room-item-header").on("click", function (e) {
        roomItemHeaderClickHandler(this);
    });

    // room with details(image/comment)

    $DOM(".room-header-det").on("click", function (e) {
        roomItemHeaderClickHandler(this);
    });

    $DOM(".add-entry").on("click", function (e) {
        closeDialogs();
        e.preventDefault();
        e.stopImmediatePropagation();

        const roomId = $DOM(this).parent().parent().parent().parent().attr("data-rid");
        $DOM("#createDataModal").removeClass("hidden");
        appendDialog($DOM("#createDataModal"));
        $DOM("#data-dataid").val("");
        $DOM("#data-rid").val(roomId);
        $DOM("#data-btncancel").on("click", closeDialogs);
        $DOM("#data-btnsave").off();
        $DOM("#data-btnsave").on("click", saveData);
    });

    $DOM(".add-detail").on("click", function (e) {
        const dataId = $DOM(this).attr("data-data-id");

        $DOM("#createDetailModal").removeClass("hidden");

        appendDialog($DOM("#createDetailModal"));

        $DOM("#createDetailHeader").html("Detail eintragen");
        $DOM("#detail-dataid").val(dataId);
        $DOM("#detail-detailid").val("");

        $DOM("#detail-btncancel").on("click", closeDialogs);
        $DOM("#detail-btnsave").off();
        $DOM("#detail-btnsave").on("click", saveDetail);
        $DOM("#detail-btndelete").off();
        $DOM("#detail-btndelete").addClass("hidden");
    });
    $DOM(".edit-detail").on("click", function (e) {
        closeDialogs();
        $DOM("#detail-form-error").html("");
        e.preventDefault();
        e.stopImmediatePropagation();

        const detailRow = $DOM(this).parent().parent();
        const detailId = $DOM(this).attr("data-detail-id");
        const dataId = $DOM(this).attr("data-data-id");

        const detail = getDetailgById(dataId, detailId);
        if (detail) {
            // console.log("dd ", detail)
            $DOM("#createDetailHeader").html("Detail Bearbeiten");
            $DOM("#createDetailModal").removeClass("hidden");
            appendDialog($DOM("#createDetailModal"));
            $DOM("#detail-serialnumber").val(detail.serialnumber);
            $DOM("#detail-anschaffung").val(detail.anschaffung);
            $DOM("#detail-auszuscheiden").val(detail.auszuscheiden);
            $DOM("#detail-lastcheck").val(detail.lastcheck);
            $DOM("#detail-nextcheck").val(detail.nextcheck);
            $DOM("#detail-kommentar").val(detail.kommentar);
            $DOM("#detail-dataid").val(detail.dataid);
            $DOM("#detail-detailid").val(detail.id);

            $DOM("#detail-btncancel").on("click", closeDialogs);
            $DOM("#detail-btnsave").off();
            $DOM("#detail-btnsave").on("click", saveDetail);
            $DOM("#detail-btndelete").off();
            $DOM("#detail-btndelete").removeClass("hidden");
            $DOM("#detail-btndelete").on("click", function (e) {
                customConfirm("Sicher das du den Datensatz löschen willst?", function () {
                    deleteDetail(detailRow);
                });
            });
        }
    });

    $DOM(".edit-room").on("click", function (e) {
        closeDialogs();
        e.preventDefault();
        e.stopImmediatePropagation();

        const rid = $DOM(this).parent().parent().parent().parent().attr("data-rid");

        $DOM("#createRoomModalHeader").html("Raum bearbeiten");

        removeRoomBild = false;
        removeRoomBild2 = false;
        removeRoomBild3 = false;
        removeRoomBild4 = false;
        const raum = getRoomById(rid);
        if (raum) {
            appendDialog($DOM("#createRoomModal"));
            let raumId = raum.rid;
            const groupid = getAttr("openGid");

            $DOM("#room-rid").val(raumId);
            $DOM("#room-name").val(raum.raumname);
            $DOM("#room-navname").val(raum.raumkurz);
            $DOM("#room-sortidx").val(raum.sortidx);
            $DOM("#room-kommentar").val(raum.raumkommentar);
            if (raum.raumbild) {
                if (raum.raumbild != "") {
                    $DOM("#room-bild")
                        .parent()
                        .append(`<span class="upload-img-name">${reduceName(raum.raumbild)}<i id="room-imgbild" class="remove-entry upload-remove"></i></span>`);
                }
            }
            if (raum.raumbild2) {
                if (raum.raumbild2 != "") {
                    $DOM("#room-bild2")
                        .parent()
                        .append(`<span class="upload-img-name">${reduceName(raum.raumbild2)}<i id="room-imgbild2" class="remove-entry upload-remove"></i></span>`);
                }
            }
            if (raum.raumbild3) {
                if (raum.raumbild3 != "") {
                    $DOM("#room-bild3")
                        .parent()
                        .append(`<span class="upload-img-name">${reduceName(raum.raumbild3)}<i id="room-imgbild3" class="remove-entry upload-remove"></i></span>`);
                }
            }
            if (raum.raumbild4) {
                if (raum.raumbild4 != "") {
                    $DOM("#room-bild4")
                        .parent()
                        .append(`<span class="upload-img-name">${reduceName(raum.raumbild4)}<i id="room-imgbild4" class="remove-entry upload-remove"></i></span>`);
                }
            }
        
            $DOM("#room-imgbild").on("click", function () {
                removeRoomBild = true;
                $DOM(this).parent().remove();
            });
            $DOM("#room-imgbild2").on("click", function () {
                removeRoomBild2 = true;
                $DOM(this).parent().remove();
            });
            $DOM("#room-imgbild3").on("click", function () {
                removeRoomBild3 = true;
                $DOM(this).parent().remove();
            });
            $DOM("#room-imgbild4").on("click", function () {
                removeRoomBild4 = true;
                $DOM(this).parent().remove();
            });


            $DOM("#createRoomModal").removeClass("hidden");
            $DOM("#room-btncancel").on("click", closeDialogs);
            $DOM("#room-btnsave").off();
            $DOM("#room-btnsave").on("click", () => {
                saveRoom(groupid);
            });

            $DOM("#room-btndelete").off();
            $DOM("#room-btndelete").on("click",
                function (e) {
                    const user = getAttr("user");
                    const gid = getAttr("openGid");
                    new HttpRequest().send({
                        url: "./php/api/room/delete.php",
                        type: "POST",
                        data: {
                            id: raumId,
                            userid: user.id,
                            oid: user.oid,
                            uid: user.uid
                        }
                    }).done(function (e) {
                        closeDialogs();
                        resetNavbar();
                        loadData(gid, true);
                    }).fail(function (e) {
                        customAlert(e);
                    });
                });
        }
    });


    $DOM(".edit-entry").on("click", function (e) {
        closeDialogs();
        $DOM("#data-form-error").html("");
        e.preventDefault();
        e.stopImmediatePropagation();
        const dataid = $DOM(this).parent().parent().parent().attr("data-id");
        removeBild1 = false;
        removeBild2 = false;

        const data = getDatagById(dataid);
        if (data) {
            $DOM("#createDataModal").removeClass("hidden");
            appendDialog($DOM("#createDataModal"));
            $DOM("#data-name").val(data.name);
            $DOM("#data-anzahl").val(data.anzahl);
            $DOM("#data-detail").val(data.raumdetail);
            $DOM("#data-kommentar").val(data.kommentar);
            $DOM("#data-dataid").val(dataid);
            $DOM("#data-rid").val(data.rid);
            if (data.bild1) {
                $DOM("#data-bild1").parent().append(`<span class="upload-img-name">${reduceName(data.bild1)}<i id="imgbild1" class="remove-entry upload-remove"></i></span>`);
            }
            if (data.bild2) {
                $DOM("#data-bild2").parent().append(`<span class="upload-img-name">${reduceName(data.bild2)}<i id="imgbild2" class="remove-entry upload-remove"></i></span>`);
            }

            $DOM("#imgbild1").on("click", function () {
                removeBild1 = true;
                $DOM(this).parent().remove();
            });
            $DOM("#imgbild2").on("click", function () {
                removeBild2 = true;
                $DOM(this).parent().remove();
            });

            $DOM("#data-btncancel").on("click", closeDialogs);
            $DOM("#data-btnsave").off();
            $DOM("#data-btnsave").on("click", saveData);
        }
    });

    $DOM(".remove-entry").on("click", function (e) {
        closeDialogs();
        e.preventDefault();
        e.stopImmediatePropagation();
        const dataRow = $DOM(this).parent().parent().parent();
        const dataid = dataRow.attr("data-id");

        var user = getAttr("user");

        const data = getDatagById(dataid);
        if (data) {
            $DOM("#deleteModal").removeClass("hidden");
            appendDialog($DOM("#deleteModal"));

            $DOM("#delete-btncancel").on("click", closeDialogs);
            $DOM("#delete-btndelete").off();
            $DOM("#delete-btndelete").on("click", function (e) {
                new HttpRequest().send({
                    url: "./php/api/data/delete.php",
                    type: "POST",
                    data: {
                        id: dataid,
                        userid: user.id,
                        oid: user.oid,
                        uid: user.uid
                    }
                }).done(function (e) {
                    closeDialogs();
                    dataRow.remove();
                    loadData(e.id, false, false);
                }).fail(function (e) {
                    customAlert(e);
                });
            });
        }
    });

    $DOM(".room-img").on("click", openImageModal);
}

function deleteDataGroup(id) {
    const user = getAttr("user");
    new HttpRequest().send({
        url: "./php/api/datagroup/delete.php",
        type: "POST",
        data: {
            id: id,
            userid: user.id,
            oid: user.oid,
            uid: user.uid
        }
    }).done(function (e) {
        closeDialogs();
        loadDatagroups();
    }).fail(function (e) {
        customAlert(e);
    });
}

function saveData() {
    const name = $DOM("#data-name").val();
    const anzahl = $DOM("#data-anzahl").val();
    const detail = $DOM("#data-detail").val();
    const kommentar = $DOM("#data-kommentar").val();
    var bild1 = $DOM("#data-bild1").getElm().files[0];
    var bild2 = $DOM("#data-bild2").getElm().files[0];
    const user = getAttr("user");
    const dataid = $DOM("#data-dataid").val();
    const rid = $DOM("#data-rid").val();
    if (name && anzahl && rid) {

        if ($DOM(`[ref-id="#data-bild1"]`).getElm()) {
            bild1 = $DOM(`[ref-id="#data-bild1"]`).attr("data-name");
        }
        if ($DOM(`[ref-id="#data-bild2"]`).getElm()) {
            bild2 = $DOM(`[ref-id="#data-bild2"]`).attr("data-name");
        }

        const dgid = getAttr("openGid");
        const formData = new FormData();
        formData.append("bild1", bild1);
        formData.append("bild2", bild2);
        formData.append("dgid", dgid);
        formData.append("orgid", user.orgid);
        formData.append("anzahl", anzahl);
        formData.append("detail", detail);
        formData.append("kommentar", kommentar);
        formData.append("rid", rid);
        formData.append("id", dataid);
        formData.append("name", name);
        formData.append("removebild1", removeBild1);
        formData.append("removebild2", removeBild2);
        formData.append("oid", user.oid);
        formData.append("uid", user.uid);

        new HttpRequest().send({
            url: "./php/api/data/create.php",
            type: "POST",
            format: "formdata",
            data: formData
        }).done(function (e) {
            closeDialogs();
            // Robustheit (G13): War die Antwort kein gueltiges JSON (z. B. ein
            // vorangestellter PHP-Fehlertext -> JSON.parse scheiterte -> rohes
            // XHR-Objekt), nicht aus kaputten Daten rendern, sondern sicher vom
            // Server nachladen.
            if (!e || typeof e.dataid === "undefined") {
                loadData(dgid, false, true);
                return;
            }
            // Kein Server-Reload: Item direkt aus den gespeicherten Daten in den
            // State uebernehmen und aus dem State neu rendern (robust gegen
            // Cache/Timing der read2-GET-Antwort).
            let dataArr = getAttr("data") || [];
            let elem = dataArr.find(function (d) {
                return d.id == e.dataid;
            });
            if (elem) {
                // Bearbeiten: vorhandenes Element aktualisieren
                elem.name = name;
                elem.anzahl = anzahl;
                elem.raumdetail = detail;
                elem.kommentar = kommentar;
                elem.bild1 = e.bild1 || "";
                elem.bild2 = e.bild2 || "";
            } else {
                // Anlegen: neues Element mit Raum-Metadaten aufbauen
                const raumArr = getAttr("raum") || [];
                const room = raumArr.find(function (r) {
                    return r.rid == rid;
                }) || {};
                dataArr.push({
                    id: e.dataid,
                    dgid: e.id,
                    rid: rid,
                    anzahl: anzahl,
                    name: name,
                    raumdetail: detail,
                    kommentar: kommentar,
                    bild1: e.bild1 || "",
                    bild2: e.bild2 || "",
                    raumname: room.raumname || "",
                    raumkurz: room.raumkurz || "",
                    raumkommentar: room.raumkommentar || "",
                    raumbild: room.raumbild || "",
                    raumbild2: room.raumbild2 || "",
                    raumbild3: room.raumbild3 || "",
                    raumbild4: room.raumbild4 || "",
                    sortidx: room.sortidx || "",
                    details: []
                });
            }
            setAttr("data", dataArr);
            updateData(dataArr);
            jumpToDataItemById(e.dataid);
        }).fail(function (e) {
            customAlert(e);
        });
    } else {
        $DOM("#data-form-error").html("Bitte Name und Anzahl angeben");
    }
}

function saveDetail(e) {
    const serialnumber = $DOM("#detail-serialnumber").val();
    const anschaffung = $DOM("#detail-anschaffung").val();
    const auszuscheiden = $DOM("#detail-auszuscheiden").val();
    const lastcheck = $DOM("#detail-lastcheck").val();
    const nextcheck = $DOM("#detail-nextcheck").val();
    const kommentar = $DOM("#detail-kommentar").val();
    const dataID = $DOM("#detail-dataid").val();
    let detailid = $DOM("#detail-detailid").val();
    if (!detailid.length) {
        detailid = null;
    }
    const user = getAttr("user");
    if (dataID) {
        const dgid = getAttr("openGid");
        const formData = new FormData();
        formData.append("dataid", dataID);
        formData.append("dgid", dgid);
        formData.append("serialnumber", serialnumber);
        formData.append("anschaffung", anschaffung);
        formData.append("auszuscheiden", auszuscheiden);
        formData.append("lastcheck", lastcheck);
        formData.append("nextcheck", nextcheck);
        formData.append("kommentar", kommentar);

        if (detailid) {
            formData.append("id", detailid);
        }
        formData.append("oid", user.oid);
        formData.append("uid", user.uid);

        new HttpRequest().send({
            url: "./php/api/detail/create.php",
            type: "POST",
            format: "formdata",
            data: formData
        }).done(function (e) {
            closeDialogs();
            // console.log("saveDataDone");
            loadData(e.id, false, true, jumpToDataItemById, e.dataid);
        }).fail(function (e) {
            customAlert(e);
        });
    } else {
        $DOM("#detail-form-error").html("Strange Error");
    }
}

function deleteDetail(detailRow) {
    const detailid = $DOM("#detail-detailid").val();
    const dataId = $DOM("#detail-dataid").val();

    const user = getAttr("user");
    const gid = getAttr("openGid");

    const detail = getDetailgById(dataId, detailid);
    if (detail) {
        new HttpRequest().send({
            url: "./php/api/detail/delete.php",
            type: "POST",
            data: {
                id: detailid,
                userid: user.id,
                oid: user.oid,
                uid: user.uid
            }
        }).done(function (e) {
            closeDialogs();
            detailRow.remove();
            loadData(gid, false, false);

        }).fail(function (e) {
            // console.log(e)
            customAlert(e);
        });
    } else {
        customAlert("strange Error");
    }
}

function saveRoom(groupId) {
    const rid = $DOM("#room-rid").val();
    const name = $DOM("#room-name").val();
    let namekurz = $DOM("#room-navname").val();
    const kommentar = $DOM("#room-kommentar").val();
    const bild = $DOM("#room-bild").getElm().files[0];
    const bild2 = $DOM("#room-bild2").getElm().files[0];
    const bild3 = $DOM("#room-bild3").getElm().files[0];
    const bild4 = $DOM("#room-bild4").getElm().files[0];
    const sortidx = $DOM("#room-sortidx").val();

    const user = getAttr("user");

    if (name) {
        if (!namekurz) {
            namekurz = name.substring(0, 3);
        }

        let formData = new FormData();
        if (rid != "") {
            formData.append("id", rid);
        }
        formData.append("groupid", groupId);
        formData.append("namekurz", namekurz);
        formData.append("name", name);
        formData.append("bild", bild);
        formData.append("bild2", bild2);
        formData.append("bild3", bild3);
        formData.append("bild4", bild4);
        formData.append("kommentar", kommentar);
        formData.append("removeBild", removeRoomBild);
        formData.append("removeBild2", removeRoomBild2);
        formData.append("removeBild3", removeRoomBild3);
        formData.append("removeBild4", removeRoomBild4);
        formData.append("sortidx", sortidx);
        formData.append("orgid", user.orgid);
        formData.append("oid", user.oid);
        formData.append("uid", user.uid);

        new HttpRequest().send({
            url: "./php/api/room/create.php",
            type: "POST",
            format: "formdata",
            data: formData
        }).done(function (e) {
            closeDialogs();
            // Robustheit (G13): War die Antwort kein gueltiges JSON (rohes XHR,
            // weil JSON.parse scheiterte), sicher vom Server nachladen statt aus
            // kaputten Daten zu rendern. groupId statt e.id (waere undefined).
            if (!e || typeof e.rid === "undefined") {
                loadData(groupId, false, true, jumpToRoomById);
                return;
            }
            // Kein Server-Reload: Raum direkt aus dem lokalen State rendern
            // (robust gegen Cache/Timing der read2-GET-Antwort), analog saveData.
            let dataArr = getAttr("data") || [];

            // Gehoeren die geladenen Daten ueberhaupt zu diesem Fahrzeug? Beim
            // ALLERERSTEN Raum schlaegt read2 mit 404 fehl -> der State kann
            // leer oder von einem anderen Fahrzeug stale sein. Dann sicher
            // vom Server nachladen (altes Verhalten).
            const belongsToGroup = dataArr.some(function (d) {
                return d.dgid == e.id;
            });
            if (!belongsToGroup) {
                loadData(e.id, false, true, jumpToRoomById, e.rid);
                return;
            }

            if (rid != "") {
                // Bearbeiten: Raum-Metadaten auf ALLEN Zeilen dieses Raums
                // aktualisieren (jede Data-Zeile traegt die Raumfelder; leere
                // Raeume haben genau eine Platzhalter-Zeile mit id == null).
                dataArr.forEach(function (d) {
                    if (d.rid == e.rid) {
                        d.raumname = name;
                        d.raumkurz = namekurz;
                        d.raumkommentar = kommentar || "";
                        d.raumbild = e.bild || "";
                        d.raumbild2 = e.bild2 || "";
                        d.raumbild3 = e.bild3 || "";
                        d.raumbild4 = e.bild4 || "";
                        d.sortidx = sortidx || "";
                    }
                });
            } else {
                // Anlegen: Platzhalter-Zeile (id == null) mit den Raum-Metadaten
                // einfuegen — entspricht der left-join-NULL-Zeile, die read2 fuer
                // einen leeren Raum liefert (createDataRowElem ueberspringt id == null).
                dataArr.push({
                    id: null,
                    dgid: e.id,
                    rid: e.rid,
                    anzahl: null,
                    name: null,
                    raumname: name,
                    raumkurz: namekurz,
                    raumkommentar: kommentar || "",
                    raumbild: e.bild || "",
                    raumbild2: e.bild2 || "",
                    raumbild3: e.bild3 || "",
                    raumbild4: e.bild4 || "",
                    sortidx: sortidx || "",
                    raumdetail: "",
                    kommentar: "",
                    bild1: "",
                    bild2: "",
                    details: []
                });
            }
            setAttr("data", dataArr);
            updateData(dataArr);
            jumpToRoomById(e.rid);
        }).fail(function (e) {
            customAlert(e);
        });
    } else {
        customAlert("Bitte einen Namen angeben");
    }
}


function jumpToDataItemById(dataId) {
    var elem = $DOM(`[data-id="${dataId}"]`).getElm().firstChild;
    elem.click();
}

function jumpToRoomById(roomId) {
    var elem = $DOM(`#room_${roomId}`).getElm();

    scrollToRoomItem(elem);
}

function searchData(val) {
    var value = val.toLowerCase();
    const datAttr = getAttr("data");
    var data;
    if (val) {
        data = datAttr.filter(a => a.name.toLowerCase().indexOf(value) > -1);
    } else {
        data = datAttr;
    }

    updateData(data);
}

function getDatagroupById(id) {
    const dg = getAttr("datagroups");
    if (dg) {
        for (let i = 0; i < dg.length; i++) {
            if (dg[i] && dg[i].id == id) {
                return dg[i];
            }
        }
    }
    return null;
}

function getRoomById(id) {
    const raum = getAttr("raum");
    if (raum) {
        for (let i = 0; i < raum.length; i++) {
            if (raum[i] && raum[i].rid == id) {
                return raum[i];
            }
        }
    }
    return null;
}

function getDatagById(id) {
    const data = getAttr("data");
    if (data) {
        for (let i = 0; i < data.length; i++) {
            if (data[i] && data[i].id == id) {
                return data[i];
            }
        }
    }
    return null;
}

function getDetailgById(dataid, detailId) {
    const data = getDatagById(dataid)
    if (data) {
        if (data.details) {
            for (let i = 0; i < (data.details).length; i++) {
                if (data.details[i] && data.details[i].id == detailId) {
                    return data.details[i];
                }
            }
        }
    }
    return null;
}

function getUserListById(id) {
    const data = getAttr("userList");
    if (data) {
        for (let i = 0; i < data.length; i++) {
            if (data[i] && data[i].id == id) {
                return data[i];
            }
        }
    }
    return null;
}

function createRoomDlg(groupid = null) {
    if (groupid == undefined || groupid == null) {
        groupid = getAttr("openGid");
    }

    closeDialogs();
    $DOM("#createRoomModalHeader").html("Raum erstellen");
    $DOM("#room-btndelete").addClass("hidden");
    $DOM("#createRoomModal").removeClass("hidden");
    $DOM("#room-rid").val("");

    appendDialog($DOM("#createRoomModal"));
    $DOM("#room-btncancel").on("click", () => {
        $DOM("#room-btndelete").removeClass("hidden");
        closeDialogs();
    });
    $DOM("#room-btnsave").off();
    $DOM("#room-btnsave").on("click", () => {
        saveRoom(groupid);
    });
}

function openImageModal() {
    closeDialogs();
    $DOM("#imageModal").getElm().style.display = "block";
    $DOM("#imgmodal").getElm().src = this.src.replace("/thumbnail/", "/");
    const parent = $DOM(this).parent().parent();
    const kommentar = parent.find("raumkommentar");
    const detail = parent.find("raumdetail");
    let txt = "";
    if (detail.getElm()) {
        txt = detail.getElm().textContent;
    }
    if (kommentar.getElm()) {
        if (txt != "") {
            txt += " - ";
        }
        txt += kommentar.getElm().textContent;
    }
    // escapeHtml: txt stammt aus textContent (Nutzertext) und wuerde per .html()
    // sonst wieder als HTML geparst -> Stored-XSS (G6).
    $DOM("#caption").html(escapeHtml(txt));
    $DOM("#close-imgmodal").off();
    $DOM("#close-imgmodal").on("click",
        function () {
            $DOM("#imageModal").getElm().style.display = "none";
        });
}


function showUserVerwaltung() {
    closeDialogs();
    resetNavbar();
    const nav = $DOM("#dropdown-items");
    nav.append(`<a role="button" class="nav-link" id="home">Zurück</a>`);

    $DOM("#home").on("click", function (e) {
        loadDatagroups();
    });

    $DOM("#btn-create-user").removeClass("hidden");

    const screen = $DOM("#list-screen");
    screen.empty();
    screen.removeClass();
    screen.addClass("screen");
    screen.addClass("bg");

    const user = getAttr("user");
    new HttpRequest().send({
        url: "./php/api/user/readUsers.php",
        type: "POST",
        data: {
            userid: user.id,
            orgid: user.orgid,
            oid: user.oid,
            uid: user.uid
        }
    }).done(function (e) {
        setAttr("userList", e);
        addUserList(e);
    }).fail(function (e) {
        customAlert(e);
    });
}

function addUserList(list) {
    const screen = $DOM("#list-screen");
    screen.empty();

    const container = $DOM().create("div");
    container.addClass("content-container");
    container.addClass("content-user");

    if (list && list.length > 0) {
        for (let i = 0; i < list.length; i++) {
            container.append(
                `<div class="user-item"><span>${escapeHtml(list[i].fullname)} (${escapeHtml(list[i].username)})</span><div data-id="${list[i].id
                }"><i class="edit-user"></i><i class="remove-user"></i></div>`);
        }
    } else {
        container.append(`<div class="user-item"><span>Keine User gefunden</span></div>`);
    }

    screen.append(container);


    $DOM(".edit-user").on("click", editUser);
    $DOM(".remove-user").on("click", removeUser);
}

function editUser(e) {
    navBarClose();
    const id = $DOM(this).parent().attr("data-id");
    if (id) {
        editUserModal(id);
    }
}

function removeUser(e) {
    navBarClose();
    var that = this;
    customConfirm("User löschen?", function (e) {
        const id = $DOM(that).parent().attr("data-id");
        if (id) {
            const user = getAttr("user");
            new HttpRequest().send({
                url: "./php/api/user/delete.php",
                type: "POST",
                data: {
                    id: id,
                    userid: user.id,
                    oid: user.oid,
                    uid: user.uid
                }
            }).done(function (e) {
                showUserVerwaltung();
            }).fail(function (e) {
                customAlert(e);
            });
        }
    });
}

function appendUserRegister() {
    closeDialogs();
    $DOM("#editUserModal").dialog("open");
    appendDialog($DOM("#editUserModal"));
    $DOM("#edituser-groupaccount").getElm().checked = false;

    $DOM("#edituser-btncancel").on("click", closeDialogs);
    $DOM("#editUserHeader").html("User hinzufügen");
    $DOM("#edituser-btnsave").off();
    $DOM("#edituser-btnsave").on("click", function () {
        $DOM("#edituser-form-error").html("");
        if (!$DOM("#edituser-email").val() || $DOM("#edituser-email").getElm().validity.typeMismatch) {
            $DOM("#edituser-form-error").html("Bitte E-Mail angeben!");
            return;
        } else if (!$DOM("#edituser-name").val()) {
            $DOM("#edituser-form-error").html("Bitte Name angeben!");
            return;
        } else if (!$DOM("#edituser-pw").val()) {
            $DOM("#edituser-form-error").html("Bitte Passwort angeben!");
            return;
        } else if (!$DOM("#edituser-pw2").val()) {
            $DOM("#edituser-form-error").html("Bitte Passwort Wiederholung angeben!");
            return;
        } else if ($DOM("#edituser-pw").val() != $DOM("#edituser-pw2").val()) {
            $DOM("#edituser-form-error").html("Passwörter stimmen nicht überein!");
            return;
        } else if ($DOM("#edituser-pw").val().length < 4) {
            $DOM("#edituser-form-error").html("Passwort muss mindestens 4 Zeichen lang sein!");
            return;
        }

        // const name = $DOM("#edituser-name").val();
        const user = getAttr("user");

        new HttpRequest().send({
            url: "./php/api/user/create.php",
            type: "POST",
            data: {
                email: $DOM("#edituser-email").val(),
                pw: $DOM("#edituser-pw").val(),
                name: $DOM("#edituser-name").val(),
                orgid: user.orgid,
                oid: user.oid,
                uid: user.uid,
                isgroupaccount: $DOM("#edituser-groupaccount").getElm().checked
            }
        }).done(function (e) {
            closeDialogs();
            showUserVerwaltung();
        }).fail(function (e) {
            const errMsg = customAlert(e);
            $DOM("#edituser-form-error").html(errMsg);

        });
    });
}

function editUserModal(id) {
    navBarClose();
    appendDialog($DOM("#editUserModal"));
    const user = getUserListById(id);

    $DOM("#editUserHeader").html("User bearbeiten");
    $DOM("#edituser-name").val(user.fullname);
    $DOM("#edituser-email").val(user.username);
    $DOM("#edituser-pw").val();

    $DOM("#edituser-form-error").html("");
    $DOM("#editUserModal").removeClass("hidden");

    // Todo: maybe remove, maybe set someone to moderate data?
    // $DOM("#edituser-admin").checked(user.admin == 1);
    $DOM("#edituser-groupaccount").checked(user.isgroupaccount == 1);
    $DOM("#edituser-btncancel").on("click", closeDialogs);
    $DOM("#edituser-btnsave").off();
    $DOM("#edituser-btnsave").on("click", function (e) {
        $DOM("#edituser-form-error").html("");
        if (!$DOM("#edituser-email").val() || $DOM("#edituser-email").getElm().validity.typeMismatch) {
            $DOM("#edituser-form-error").html("Bitte E-Mail angeben");
            return;
        } else if (!$DOM("#edituser-name").val()) {
            $DOM("#edituser-form-error").html("Bitte Name angeben");
            return;
        }
        if ($DOM("#edituser-pw").val() || $DOM("#edituser-pw2").val()) {
            if (!$DOM("#edituser-pw").val()) {
                $DOM("#edituser-form-error").html("Bitte Passwort angeben");
                return;
            } else if (!$DOM("#edituser-pw2").val()) {
                $DOM("#edituser-form-error").html("Bitte Passwort Wiederholung angeben");
                return;
            } else if ($DOM("#edituser-pw").val() != $DOM("#edituser-pw2").val()) {
                $DOM("#edituser-form-error").html("Passwörter stimmen nicht überein");
                return;
            }
        }

        const name = $DOM("#edituser-name").val();
        const user = getAttr("user");

        if (name) {
            new HttpRequest().send({
                url: "./php/api/user/update.php",
                type: "POST",
                data: {
                    email: $DOM("#edituser-email").val(),
                    pw: $DOM("#edituser-pw").val(),
                    name: $DOM("#edituser-name").val(),
                    id: id,
                    oid: user.oid,
                    uid: user.uid,
                    isgroupaccount: $DOM("#edituser-groupaccount").getElm().checked
                }
            }).done(function (e) {
                closeDialogs();
                showUserVerwaltung();
            }).fail(function (e) {
                customAlert(e);
            });
        }
    });
}

function showImagePicker(ref) {

    if (!ref) {
        customAlert("Keine Referenz für das Result Bild gefunden");
        return;
    }
    $DOM(".imagepicker-li.active").removeClass("active");
    $DOM("#imagepicker-body").empty();

    $DOM("#imagepickerModal").removeClass("hidden");
    appendDialog($DOM("#imagepickerModal"), false);

    $DOM("#imagepicker-btncancel").off();
    $DOM("#imagepicker-btncancel").on("click", function () {
        closeOneDialog($DOM("#imagepickerModal"));
    });
    $DOM("#imagepicker-btnok").off();
    $DOM("#imagepicker-btnok").on("click", function () {
        const li = $DOM(".imagepicker-li.active").getElm();
        if (li && li.children) {
            const img = li.children[0];
            const src = img.src;
            const name = src.split("thumbnail/")[1];
            ref = ref.startsWith("#") ? ref : "#" + ref;

            $DOM(ref).parent().find(".upload-img-name").elm.forEach((elm) => {
                $DOM(elm).remove();
            });

            $DOM(ref).parent().append(`<span class="upload-img-name">${reduceName(name)}<i ref-id="${ref}" data-name="${name
                }" class="remove-entry-imagepicker remove-entry upload-remove"></i></span>`);
            $DOM(".remove-entry-imagepicker").off();
            $DOM(".remove-entry-imagepicker").on("click", function () {
                $DOM(this).parent().remove();
            });
            closeOneDialog($DOM("#imagepickerModal"));
        }
    });

    var gid = getAttr("openGid");
    var user = getAttr("user");
    new HttpRequest().send({
        url: "./php/api/datagroup/readimages.php",
        type: "GET",
        data: {
            dgid: gid,
            id: user.id,
            uid: user.uid
        }
    }).done(function (e) {
        var globalPath = `/data/img/${user.oid}/${gid}/thumbnail/`;
        $DOM("#imagepicker-body").empty();
        var ul = $DOM().create("ul");
        ul.addClass("imagepicker-ul");
        e.forEach((path) => {
            var img = `<li class="imagepicker-li"><img class="imagepicker-img" src="${globalPath}${path}" /></li>`;
            ul.append(img);
        });
        ul.append(`<li class="imagepicker-li-last"></li>`);
        $DOM("#imagepicker-body").append(ul);

        $DOM(".imagepicker-li").off();
        $DOM(".imagepicker-li").on("click", function () {
            const hasClass = $DOM(this).hasClass("active");

            $DOM(".imagepicker-li.active").removeClass("active");
            if (!hasClass) {
                $DOM(this).addClass("active");
            }
        });

    }).fail(function (e) {
        customAlert(e);
    });
}

function reduceName(name) {
    return name.length > 20 ? name.substring(0, 20) + "..." : name;
}

function createElementFromHTML(htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();

    // Change this to div.childNodes to support multiple top-level nodes
    return div.firstChild;
}


export {
    liste,
    createGroup,
    showUserVerwaltung,
    btnBackListe,
    benutzerVerwaltung,
    showImagePicker,
    loadDatagroups,
    appendUserRegister,
    createRoomDlg
}